import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Typography,
  Tag,
  List,
  Input,
  Radio,
  message,
  Checkbox,
  Tooltip,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  BellOutlined,
  TeamOutlined,
  DownloadOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import { URL } from "../../helper/Mainurl";
import DetailsList from "../DetailsList";
import DateModalTask from "./DateModalTask";
import TimeSelect from "./TimeSelect";
import Reminder from "./Reminder";
import FloatLabel from "../FloatLabel";
import ChecklistComponent from "../ChecklistComponent";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import moment from "moment";
import axios from "axios";
import {
  AssessmentOutlined,
  AssignmentOutlined,
  ColorLensOutlined,
  RepeatOnOutlined,
} from "@mui/icons-material";
import DeleteConfirmationModal from "../DeleteConfirmationModal";
import CollaborationModal from "./CollaborationModal";
import AssignToModal from "./AssignToModal";
import ColorsModal from "./ColorsModal";
import RepeatModal from "./RepeatModal";
import RecurringEventModal from "../../Components/Modals/DeleteAndUpdateModal/DeleteAndUpdateModal";
import { useUserInfo } from "../../contexts/userInfo";

const { Text } = Typography;

const ViewEvent = ({ isOpen, onCancel, eventData, onSuccess }) => {
  const { userInfo } = useUserInfo();
  const token = localStorage.getItem("authToken");
  // console.log("eventData___", eventData);

  // Fetch CollaborateDate
  const [AssignData, setAssignData] = useState([]);
  const [dummyCollaborators, setDummyCollaborators] = useState([]);
  const [permission, setPermission] = useState([]);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [showCollaborationModal, setShowCollaborationModal] = useState(false);
  const [invitees, setInvitees] = useState();
  const [selectedCollaborators, setSelectedCollaborators] = useState([]);
  const [switchStatesCollaboration, setSwitchStatesCollaboration] =
    useState(false);
  const [descSelectedReminder, setDescSelectedReminder] =
    useState("No reminder");
  const [repeatConfig, setRepeatConfig] = useState(null);
  const [descSelectedColor, setDescSelectedColor] = useState("No color");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedReminder, setSelectedReminder] = useState("No reminder");
  const [selectedColor, setSelectedColor] = useState(null);
  //switch buttons
  const [switchStates, setSwitchStates] = useState(false);
  const [switchTimeStates, setSwitchTimeStates] = useState(false);
  const [switchStatesRem, setSwitchStatesRem] = useState(false);
  const [switchStatesRepeat, setSwitchStatesRepeat] = useState(false);
  const [switchStatesColor, setSwitchStatesColor] = useState(false);
  const [metaLoading, setMetaLoading] = useState(false);

  //Modal
  const [showRepeatModal, setShowRepeatModal] = useState(false);

  // Add these state declarations at the top of your component
  const [selectedRadio, setSelectedRadio] = useState("");
  const [selectedPriorityIds, setSelectedPriorityIds] = useState(null);
  const [selectedDisplayId, setSelectedDisplayId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [taskDetails, setTaskDetails] = useState(null);
  const [participants, setParticipants] = useState(null);
  const [editView, setEditView] = useState(false);
  const [error, setError] = useState(false);

  //Modal toggle states
  const [showColorModal, setShowColorModal] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [showRemModal, setShowRemModal] = useState(false);

  // Metadata
  const [progressStatus, setProgressStatus] = useState([]);
  const [displayName, setDisplayName] = useState([]);
  const [priority, setPriority] = useState([]);
  const [colorMetaData, setColorMetaData] = useState([]);
  const [getAssignee, setGetAssignee] = useState([]);
  const [getCollaboraters, setGetCollabraters] = useState([]);
  const [repeatOption, setRepeatOption] = useState([]);
  const [adjusWeekend, setAdjustWeekend] = useState([]);
  const [checklist, setChecklist] = useState([]);

  // Delete Modals status
  const [isModalVisible, setIsModalVisible] = useState(false); // delete modal visible state
  const [isModaUpdatelVisible, setIsUpdateModalVisible] = useState(false); // delete modal visible state
  const [selectedItemForDelete, setSelectedItemForDelete] = useState(null); // confirm deleteType
  const [assignBy, setAssignBy] = useState(null);

  const [selectedTime, setSelectedTime] = useState({
    start: null,
    end: null,
  });
  const [attachmentModal, setAttachmentModal] = useState({
    visible: false,
    attachments: [],
  });

  // Form state
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    location: "",
    display_name_id: null,
    priority_id: null,
    progress_status_id: "",
    start_date: "",
    start_time: "",
    end_time: "",
    reminder_timestamp: "",
    color_id: null,
  });
  // Fetch task details
  const fetchTaskDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${URL}/v1/calendar/task-event-details/${eventData.event_id}`,
        {
          params: {
            type: "event",
            occurrence_date: moment(eventData.start).format("YYYY-MM-DD"),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.code === 200) {
        setTaskDetails(response.data.data);
        setAssignBy(response.data.data.assigned_by || {});
        setChecklist(response.data.data.checklist || []);
        initializeFormData(response.data.data);
        setParticipants(response?.data?.data?.participants);
      }
    } catch (error) {
      console.error("Error fetching task details:", error);
      message.error("Failed to load task details");
    } finally {
      setLoading(false);
    }
  };
  const getReminderPresetLabel = (startTime, reminderTime) => {
    if (!startTime || !reminderTime) return "No reminder";
    const start = moment.utc(startTime);
    const reminder = moment.utc(reminderTime);
    const diffMinutes = start.diff(reminder, "minutes");
    const diffHours = start.diff(reminder, "hours") || 0;
    const diffDays = start.diff(reminder, "days") || 0;
    if (diffMinutes === 5) return "5 minute before";
    if (diffMinutes === 30) return "30 minute before";
    if (diffMinutes === 60) return "1 hour before";
    if (diffMinutes === 1440) return "1 day before";
    if (diffDays === 0 && diffHours === 0 && diffMinutes > 0) {
      return `${diffMinutes} minutes before`;
    } else if (diffDays === 0 && diffHours > 0) {
      return `${diffHours} hours, ${diffMinutes % 60} minutes before`;
    } else if (diffDays > 0) {
      return `${diffDays} days, ${diffHours % 24} hours, ${
        diffMinutes % 60
      } minutes before`;
    }
    return "No reminder";
  };
  // Initialize form data
  const initializeFormData = (data) => {
    setFormData({
      title: data.title || "",
      description: data.description || "",
      location: data.location || "",
      display_name_id: data.display_name_id || null,
      priority_id: data.priority_id || null,
      progress_status_id: data.progress_status_id || "",
      start_date: data.start_date || "",
      start_time: data.start_time || "",
      end_time: data.end_time || "",
      reminder_timestamp: data.reminder_timestamp || "",
      color_id: data.color_id || null,
    });

    // Set selected states for UI components
    setSelectedRadio(Number(data.progress_status_id));
    setSelectedPriorityIds(Number(data.priority_id));
    setSelectedDisplayId(Number(data.display_name_id));
    setGetAssignee(data.participants);

    const initialSelected = data.participants.map((collab) => ({
      ...collab.member,
      permission: collab.permission, // Include the permission data
    }));
    setSelectedCollaborators(initialSelected);
    setGetCollabraters(data.participants);

    //initial switch toggle
    setSwitchStatesCollaboration(data.participants.length > 0 || false);
    // if (data?.color_id && colorMetaData && colorMetaData?.length > 0) {
    //   // console.log("eventData?.color",eventData.color, colorMetaData)
    //   const matchedColor = colorMetaData.find(
    //     (c) => c.id === eventData.color_id
    //   );
    //   // console.log("matchedColor", matchedColor)
    //   if (matchedColor) {
    //     setSelectedColor(matchedColor);
    //     setDescSelectedColor(matchedColor?.label_name);
    //     setSwitchStatesColor(true);
    //   }
    // }
    // setGetCollabraters([])

    //eventData
    setSelectedReminder(eventData.reminder);
  };

  useEffect(() => {
    if (eventData?.color_id === 0 || eventData?.color_id === null) {
      setSelectedColor(null);
      setDescSelectedColor("No color");
      setSwitchStatesColor(false);
      return;
    }

    if (eventData?.color_id && colorMetaData?.length > 0) {
      const matchedColor = colorMetaData.find(
        (c) => c.id === eventData.color_id
      );
      if (matchedColor) {
        setSelectedColor(matchedColor);
        setDescSelectedColor(matchedColor.label_name);
        setSwitchStatesColor(true);
      } else {
        // fallback (in case API sends an ID not in metadata)
        setDescSelectedColor("No color");
        setSelectedColor(null);
      }
    }
  }, [eventData, colorMetaData]);

  useEffect(() => {
    if (eventData?.start) {
      setSelectedDate(moment.utc(eventData.start).format("D, MMMM YYYY"));
      setSwitchStates(true); // ✅ Enable switch if start date exists
    } else {
      setSelectedDate("No Date");
      setSwitchStates(false); // Reset switch if no date found
    }

    if (eventData?.start && eventData?.end) {
      setSelectedTime({
        start: moment.utc(eventData.start).format("HH:mm"),
        end: moment.utc(eventData.end).format("HH:mm"),
      });
      setSwitchTimeStates(true); // ✅ Enable switch if time exists
    } else {
      setSwitchTimeStates(false);
    }
    if (eventData?.reminder && eventData?.start) {
      let reminderText = eventData?.reminder
        ? getReminderPresetLabel(eventData.start, eventData.reminder)
        : "No reminder";

      setDescSelectedReminder(reminderText);
      setSwitchStatesRem(true); // ✅ Enable switch if reminder exists
    } else {
      setDescSelectedReminder("No reminder");
      setSwitchStatesRem(false); // ✅ Disable switch if no reminder
    }
  }, [eventData?.start, eventData?.end, eventData?.reminder]);

  useEffect(() => {
    // console.log("Received eventData in ViewTask:", {eventData});
    if (!eventData) return;

    const startDate = moment(eventData.start);
    const repeatType = eventData.repeat_option || "daily";
    const endDate = eventData.repetition_end_date
      ? moment(eventData.repetition_end_date)
      : null;
    const endType = endDate ? "custom" : "after";

    let occurrences = 2; // default fallback
    if (endDate && startDate.isBefore(endDate)) {
      switch (repeatType) {
        case "daily":
          occurrences = endDate.diff(startDate, "days") + 1;
          break;
        case "weekly":
          occurrences = endDate.diff(startDate, "weeks") + 1;
          break;
        case "monthly":
          occurrences = endDate.diff(startDate, "months") + 1;
          break;
        default:
          break;
      }
    }

    const excludeWeekends = [];
    if (eventData.exclude_saturdays === "1") {
      excludeWeekends.push({ id: 2, label: "saturday" });
    }
    if (eventData.exclude_sundays === "1") {
      excludeWeekends.push({ id: 3, label: "sunday" });
    }

    // Only set repeatConfig and switchStatesRepeat if repeat_option or repetition_end_date is present
    if (eventData.repeat_option || eventData.repetition_end_date) {
      const values = {
        repeatType: { value: repeatType },
        endType,
        occurrences,
        customEndDate: endDate ? endDate.format("YYYY-MM-DD") : null,
        excludeWeekends,
        adjustWeekends: eventData.adjust_weekends || false,
      };
      setRepeatConfig(values);
      setSwitchStatesRepeat(true);
    } else {
      setRepeatConfig(null);
      setSwitchStatesRepeat(false);
    }
  }, [eventData]);

  const resetFormFields = () => {
    setFormData({
      title: "",
      description: "",
      location: "",
      display_name_id: null,
      priority_id: null,
      progress_status_id: "",
      start_date: "",
      start_time: "",
      end_time: "",
      reminder_timestamp: "",
      color_id: null,
    });
    setSelectedTime({ start: "", end: "" });
    setSelectedReminder("No reminder");
    setDescSelectedReminder("No reminder");
    setDescSelectedColor("No color");
    setSelectedColor(null);
    setSelectedDisplayId(null);
    setSelectedPriorityIds(null);
    setSwitchStatesCollaboration(false);
    setSwitchStatesRepeat(false);
    setSwitchStates(false);
    setSwitchTimeStates(false);
    setSwitchStatesRem(false);
    setAssignedUsers([]);
    setSelectedCollaborators([]);
    setGetAssignee([]);
    setGetCollabraters([]);
    setRepeatConfig(null);
    setEditView(true); // stay in edit mode
  };

  const getCalenderMetaData = async () => {
    try {
      setMetaLoading(true); // Start loader
      const response = await fetch(`${URL}/v1/calendar/get-calendar-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data.code == 200) {
        setProgressStatus(data.data.progress_status);
        setDisplayName(data.data.display_name);
        setPriority(data.data.priority);
        setRepeatOption(data.data.repeat_option);
        setColorMetaData(data.data.colors);
      } else {
        console.error("Invalid response from server:", data);
      }
    } catch (error) {
      // Optionally handle error
    } finally {
      setMetaLoading(false); // Stop loader
    }
  };

  const iconStyle = { fontSize: 22, color: "#666", marginRight: 8 };

  const descSelectedCollaboration =
    selectedCollaborators.length > 0 || (invitees?.length ?? 0) > 0
      ? [
          ...selectedCollaborators.map((c) => c.name),
          ...(invitees || []).map((i) => i.email.split("@")[0]),
        ].join(", ")
      : "No Participants Selected";

  const selectedNames =
    (Array.isArray(assignedUsers)
      ? AssignData.filter((u) => assignedUsers?.some((a) => a.id === u.id))
      : []
    )
      .map((u) => u.name)
      .join(", ") || "No assign";

  const getRepeatDescription = () => {
    if (!switchStatesRepeat || !repeatConfig) return "No repeat";

    const { repeatType, endType, occurrences, customEndDate } = repeatConfig;

    if (!repeatType) return "No repeat";

    // Map repeatType string to a label
    const repeatLabels = {
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
    };

    const repeatLabel = repeatLabels[repeatType] || "Custom";

    const endText =
      endType === "custom"
        ? `until ${moment(customEndDate).format("D MMMM YYYY")}`
        : `after ${occurrences} ${occurrences === 1 ? "year" : "years"}`;

    return `${repeatLabel} (Ends ${endText})`;
  };

  const handleSaveCollaboration = (selected) => {
    // console.log("Selected collaborators before state update:", selected);

    // Separate new invitees
    const newInvites = selected.filter((user) => user.newInvitee);
    const confirmedCollaborators = selected.filter((user) => !user.newInvitee);

    // Set only confirmed collaborators
    setSelectedCollaborators(confirmedCollaborators);
    // console.log("setSelectedCollaborators", selectedCollaborators)

    setSwitchStatesCollaboration(confirmedCollaborators.length > 0);
    setShowCollaborationModal(false);

    // Add new confirmed collaborators to dummyCollaborators if not already present
    const newCollaborators = confirmedCollaborators.filter(
      (sel) => !dummyCollaborators.some((c) => c.id === sel.id)
    );

    if (newCollaborators.length > 0) {
      setDummyCollaborators((prev) => [...prev, ...newCollaborators]);
    }

    // Extract and set unique invitees
    if (newInvites.length > 0) {
      const invitePayload = newInvites.map((invitee) => ({
        email: invitee.email,
        permission_id: String(invitee.permission.id),
      }));
      setSwitchStatesCollaboration(true);
      setInvitees((prev = []) => {
        const existingEmails = new Set(prev.map((i) => i.email));
        const filteredNew = invitePayload.filter(
          (i) => !existingEmails.has(i.email)
        );
        return [...prev, ...filteredNew];
      });
    }
  };

  const handleRepeatCancel = () => {
    // If no config and switch is off, don't keep modal open
    if (!repeatConfig) {
      setSwitchStatesRepeat(false);
    }
    setShowRepeatModal(false);
  };
  const handleRepeatSave = (data) => {
    setRepeatConfig(data);
    setSwitchStatesRepeat(true);
    setShowRepeatModal(false);
  };

  const handleColorSave = (selectedColor) => {
    console.log("handleColorSave", selectedColor);
    // if (!selectedColor) return;
    console.log("selectedColorselectedColorselectedColor", selectedColor);
    setFormData((prev) => ({
      ...prev,
      color_id: selectedColor ? Number(selectedColor?.id) : null,
    }));
    setDescSelectedColor(selectedColor?.label_name);
    setSwitchStatesColor(selectedColor?.id ? true : false);
    setSelectedColor(selectedColor);
    message.success("Color added successfully");

    // ✅ Close modal
    setShowColorModal(false);
  };
  const handleSwitchChangeRem = () => {
    console.log("handleSwitchChangeRem", switchStatesRem);
    const newState = !switchStatesRem;

    if (newState) {
      // Trying to turn ON → open modal first
      setShowRemModal(true);
    } else {
      // Turning OFF → reset reminder
      setDescSelectedReminder("No reminder");
      setSwitchStatesRem(false);
    }
  };

  const handleRemModalClose = () => {
    if (!descSelectedReminder || descSelectedReminder === "No reminder") {
      setSwitchStatesRem(false); // Reset switch if nothing chosen
    }
    setShowRemModal(false);
  };
  const handleSwitchChangeRepeat = () => {
    const newState = !switchStatesRepeat;
    setSwitchStatesRepeat(newState);

    if (newState) {
      // Show modal when turning on
      setShowRepeatModal(true);
    } else {
      // Clear config when turning off
      setRepeatConfig(null);
    }
  };

  const handleSwitchChangeColor = () => {
    const newState = !switchStatesColor;
    setSwitchStatesColor(newState);

    if (newState) {
      // If turning ON, open the modal
      setShowColorModal(true);
    } else {
      // If turning OFF, just turn off the switch, don't open modal
      setSelectedColor(null);
      setDescSelectedColor("No color");
    }
  };

  const formatDateTimeRem = (selectedDate, selectedTime, selectedReminder) => {
    const validReminderMap = {
      5: "5 minute before",
      30: "30 minute before",
      60: "1 hour before",
      1440: "1 day before",
    };

    const formattedDate = moment(selectedDate, [
      "D MMMM YYYY",
      "DD, MMMM YYYY",
      "YYYY-MM-DD",
      "MM/DD/YYYY",
      "DD MMM YYYY",
    ]);

    if (!formattedDate.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid date" };
    }

    const formattedStartTime = moment(selectedTime?.start, [
      "HH:mm",
      "HH:mm:ss",
    ]);
    if (!formattedStartTime.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid time" };
    }

    const taskStart = moment.utc(
      `${formattedDate.format("YYYY-MM-DD")}T${formattedStartTime.format(
        "HH:mm"
      )}:00Z`
    );

    const taskStartTime = taskStart.format("YYYY-MM-DDTHH:mm:ss[Z]");
    if (!selectedReminder) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const reminderTime = moment.utc(selectedReminder);

    if (!reminderTime.isValid() || !reminderTime.isBefore(taskStart)) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const diffMinutes = taskStart.diff(reminderTime, "minutes");

    if (validReminderMap[diffMinutes]) {
      return { taskStartTime, reminderText: validReminderMap[diffMinutes] };
    }

    // Compute human-readable fallback for Customize...
    const totalMinutes = diffMinutes;
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    let parts = [];
    if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
    if (hours > 0) parts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);

    const customizeLabel =
      parts.length > 0 ? `${parts.join(", ")} before` : "Customize...";
    console.log(customizeLabel);

    return { taskStartTime, reminderText: customizeLabel };
  };

  const handleSelectReminder = (reminder) => {
    console.log("handleSelectReminder :::", selectedTime);
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      reminder
    );
    setSelectedReminder(reminder);
    setDescSelectedReminder(reminderText);
    setSwitchStatesRem(!!reminder);
  };

  const fetchCollabaroteDate = async () => {
    try {
      const response = await fetch(`${URL}/v1/member/get-members-list`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        if (data?.data) {
          const { members, permissions } = data.data;

          const transformAssign = members.map((member) => ({
            id: Number(member.id),
            name: member.name,
            email: member.email,
            avatar: member.profile_image,
          }));

          const transformedCollaborators = members.map((member) => ({
            id: String(member.id),
            name: member.invitee_nickname,
            email: member.email,
            avatar: member.profile_image,
          }));

          const transformPermission = permissions;

          // console.log("AssignData", transformAssign);
          // console.log("transformPermission", transformPermission);

          setAssignData(transformAssign);
          setDummyCollaborators(transformedCollaborators);
          setPermission(transformPermission);
        }
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
    } catch (error) {}
  };

  useEffect(() => {
    if (isOpen && eventData) {
      fetchTaskDetails();
      getCalenderMetaData();
      fetchCollabaroteDate();
    }
  }, [isOpen, eventData]);

  const handleEditOpen = () => {
    setEditView(true);
  };

  const handleClose = () => {
    setEditView(false);
    onCancel();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "title" && value.trim()) setError(false);
  };

  const handleDateSelect = (date) => {
    console.log("datehandleDateSelect", date);
    const formattedDate = moment(date).format("D, MMMM YYYY");
    setSelectedDate(formattedDate);

    // setSelectedDate(date);
    setShowModal(false); // Close modal after selecting a date
    setSwitchStates(!!date); // Correctly update state
    // const formattedDate = moment(date).format("YYYY-MM-DD");
    // setFormData(prev => ({ ...prev, start_date: formattedDate }));
    // setShowModal(false);

    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      selectedReminder
    );

    setDescSelectedReminder(reminderText);
  };

  // const handleSelectTime = (timeData) => {
  //   setFormData(prev => ({
  //     ...prev,
  //     start_time: `${prev.start_date}T${timeData.start}:00.000000Z`,
  //     end_time: `${prev.start_date}T${timeData.end}:00.000000Z`
  //   }));
  //   setShowTimeModal(false);
  // };

  const handleSelectTime = (timeData) => {
    // console.log("SelectedTime:", timeData);

    const formattedStartTime = moment(timeData.start, "HH:mm");
    const formattedEndTime = moment(timeData.end, "HH:mm");

    const formattedTime = {
      start: formattedStartTime.format("HH:mm"),
      end: formattedEndTime.format("HH:mm"),
    };

    // console.log("Formatted Time:", formattedTime);

    setSelectedTime(formattedTime);
    setSwitchTimeStates(!!timeData);
    setDescSelectedReminder("No reminder");
    setSwitchStatesRem(false);
  };

  // const handleSelectReminder = (reminder) => {
  //   setFormData(prev => ({ ...prev, reminder_timestamp: reminder }));
  //   setShowRemModal(false);
  // };
  const formatISOTime = (dateString, timeString) => {
    return moment(`${dateString} ${timeString}`)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
  };

  const handleUpdateTask = async (
    type,
    taskId,
    occurrenceDate,
    update_type = "current"
  ) => {
    if (!formData.title.trim()) {
      setError(true);
      message.error("Event name is required!");
      return;
    }
    // const payload = {
    //   ...formData,
    //   start_time: formatISOTime(formData.start_date, formData.start_time),
    //   end_time: formatISOTime(formData.start_date, formData.end_time),
    //   reminder_timestamp: formatISOTime(formData.start_date, formData.reminder_time),
    //   update_type: "all"
    // };

    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );
    let formattedDate = moment(
      formattedStartDate,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );

    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }

    let formattedStartTime = moment(
      selectedTime?.start,
      ["HH:mm", "HH:mm:ss"],
      true
    );
    const taskStartTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime.format(
          "HH:mm"
        )}`
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    let formattedEndTime = moment(
      selectedTime?.end,
      ["HH:mm", "HH:mm:ss"],
      true
    );
    const taskEndTime = moment
      .utc(
        `${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime.format(
          "HH:mm"
        )}`
      )
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    // console.log("formattedStartDate", taskEndTime)
    const formattedReminder = moment(
      selectedReminder,
      "YYYY-MM-DD HH:mm"
    ).format("YYYY-MM-DDTHH:mm:ss[Z]");

    // const checkListItems = checklist?.map(({ checklist_id, title, description = null, checked, new_status }) => ({
    //   checklist_id: new_status ? null : checklist_id,
    //   title,
    //   description,
    //   is_checked: checked ? 1 : 0
    // })) || [];
    // console.log("eventType>>>>>", checkListItems)
    // Determine if it's a task or event and structure the payload accordingly

    const calculateEndDate = (repeatConfig) => {
      if (!repeatConfig || !formattedStartDate) return null;
      const { endType, occurrences, customEndDate } = repeatConfig;
      if (endType === "custom" && customEndDate) {
        return moment(customEndDate).format("YYYY-MM-DD");
      }
      return moment(formattedStartDate)
        .add(occurrences, "years")
        .format("YYYY-MM-DD");
    };
    // console.log("checklist",checklist[0].id.toString().length)
    const checkListItems =
      checklist &&
      checklist.map((item) => ({
        id: item.id && item.id.toString().length == 13 ? null : item.id, // Use null for new items
        title: item.title,
        is_checked: item.is_checked ? 1 : 0,
        // checklist_id: item.id && item.id.toString().length == 13 ? null : item.id,
      }));
    const hasSaturday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "saturday"
    );
    const hasSunday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "sunday"
    );

    let adjustWeekendsValue = null;

    if (repeatConfig?.adjustWeekends) {
      if (hasSaturday && hasSunday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSaturday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSunday) {
        adjustWeekendsValue = "previous_saturday";
      }
    }
    console.log("update_type", update_type);
    const payload = {
      title: formData.title,
      location: formData.location,
      description: formData.description,
      display_name_id: formData.display_name_id,
      priority_id: formData.priority_id,
      progress_status_id: selectedRadio,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      end_time: taskEndTime,
      check_list:
        checkListItems && checkListItems.length > 0
          ? checkListItems
          : undefined,
      reminder_timestamp: switchStatesRem ? formattedReminder : null,
      // deleted_check_list: deletedChecklistIds,
      repeat_option: repeatConfig?.repeatType?.value || null,
      repetition_end_date:
        repeatConfig?.endType === "custom"
          ? moment(repeatConfig.customEndDate).format("YYYY-MM-DD")
          : calculateEndDate(repeatConfig),
      exclude_saturdays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "saturday"
      )
        ? true
        : false,
      exclude_sundays: repeatConfig?.excludeWeekends?.some(
        (w) => w.label === "sunday"
      )
        ? true
        : false,
      adjust_weekends: adjustWeekendsValue,
      color_id: switchStatesColor ? selectedColor?.id : null,
      assignees: assignedUsers && assignedUsers?.map((user) => user.id),
      participants:
        selectedCollaborators &&
        selectedCollaborators?.map((collaborator) => {
          console.log("collaboratorcollaboratorcollaborator", collaborator);
          return {
            member_id: parseInt(collaborator?.id),
            permission_id: collaborator?.permission?.id,
          };
        }),
      // ...(eventType === "event" && { check_list: checkListItems }), // Only add checklist for events
      occurrence_date: moment(eventData.start).format("YYYY-MM-DD"),
      // ...(update_type !== "all" && { occurrence_date :occurrenceDate,}),
      update_type: repeatConfig?.repeatType?.value ? update_type : "current",
      invitees: invitees,
    };
    console.log("payload", payload);
    // return
    try {
      setLoading(true);
      const response = await axios.post(
        `${URL}/v1/event/update/${taskDetails.event_master_id}`,
        {
          ...payload,
          // update_type: "all",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === 200) {
        message.success("Event updated successfully");
        onSuccess();
        handleClose();
      } else {
        message.error(response.data.message || "Failed to update Event");
      }
    } catch (error) {
      console.error("Error updating task:", error);
      message.error(
        error?.response?.data?.message ||
          error.message ||
          "Error updating event"
      );
    } finally {
      setLoading(false);
    }
  };

  // const deleteTask = async () => {
  //   try {
  //     await axios.delete(
  //       `${URL}/v1/event/delete/${taskDetails.event_master_id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //         data: {
  //           delete_type: "current_and_upcoming",
  //           occurrence_date: moment(eventData.start).format("YYYY-MM-DD"),
  //         },
  //       }
  //     );
  //     message.success("Task deleted successfully");
  //     onSuccess();
  //     setIsDeleteModalVisible(false);
  //     handleClose();
  //   } catch (error) {
  //     console.error("Error deleting task:", error);
  //     message.error("Failed to delete task");
  //   }
  // };

  const deleteTaskById = async (
    type,
    taskId,
    occurrenceDate,
    deleteType = "current"
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const payload = {
        delete_type: deleteType,
        ...(deleteType !== "all" && { occurrence_date: occurrenceDate }),
        id: eventData?.task_id,
      };

      const response = await axios.delete(
        `${URL}/v1/${type.toLowerCase()}/delete/${taskId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: payload,
        }
      );

      message.success("Task deleted successfully");
      return response.data;
    } catch (error) {
      message.success("Error deleting task");
      console.error("Error deleting task:", error);
      throw error;
    }
  };

  const handleDeleteTaskEvent = async (type, taskOReventId, occurrenceDate) => {
    if (eventData.repeat_option) {
      setSelectedItemForDelete({
        type,
        id: taskOReventId,
        occurrenceDate,
      });
      setIsModalVisible(true);
    } else {
      setSelectedItemForDelete({
        type,
        id: taskOReventId,
        occurrenceDate,
      });
      // Directly delete if not recurring
      setIsDeleteModalVisible(true);
      // try {
      //   await deleteTaskById(type, taskOReventId, occurrenceDate, "all");
      //   onCancel();    // Close modal
      //   onSuccess && onSuccess();
      // } catch (err) {
      //   // Optionally handle error
      //   console.error("Failed to delete task", err);
      // }
    }
  };

  const handleConfirmDelete = async (payload) => {
    try {
      const { type, id, occurrenceDate } = selectedItemForDelete;
      await deleteTaskById(
        type,
        id,
        occurrenceDate,
        payload?.update_type || "current"
      );
    } catch (err) {
      console.error("Failed to delete task", err);
    } finally {
      setIsModalVisible(false);
      onCancel();
      onSuccess();
    }
  };

  // handleUpdateTask

  const handleUpdateEvent = async (type, taskOReventId, occurrenceDate) => {
    setSelectedItemForDelete({
      type,
      id: taskOReventId,
      occurrenceDate,
    });
    console.log(
      "handleUpdateTask:::",
      eventData.repeat_option,
      repeatConfig?.repeatType?.value
    );
    if (eventData.repeat_option) {
      setIsUpdateModalVisible(true);
    } else {
      console.log("selectedItemForDelete", selectedItemForDelete);
      // const { type, id, occurrenceDate } = selectedItemForDelete ? selectedItemForDelete : null;
      await handleUpdateTask(type, taskOReventId, occurrenceDate, "all");
    }
  };

  const handleConfirmUpdate = async (payload) => {
    try {
      const { type, id, occurrenceDate } = selectedItemForDelete;
      // await handleUpdateTask();
      console.log("handleConfirmUpdate", {
        type,
        id,
        occurrenceDate,
        update_type: payload?.update_type,
      });
      await handleUpdateTask(type, id, occurrenceDate, payload.update_type);
    } catch (err) {
      console.error("Failed to delete task", err);
    } finally {
      setIsUpdateModalVisible(false);
      onCancel();
      onSuccess();
    }
  };

  if (!taskDetails) return null;

  // Helper functions for display
  const getLabelById = (list, id) => {
    if (id === 0 || id === null) return "No color";
    return list.find((item) => item.id === Number(id))?.label_name || "Unknown";
  };
  const statusLabel = getLabelById(
    progressStatus,
    taskDetails.progress_status_id
  );
  const priorityLabel = getLabelById(priority, taskDetails.priority_id);
  const displayLabel = getLabelById(displayName, taskDetails.display_name_id);
  const colorLabel = getLabelById(colorMetaData, taskDetails.color_id);

  // Format dates/times
  const formattedDate = moment(taskDetails.start_date).format("D, MMMM YYYY");
  const startTime = moment(taskDetails.start_time).format("HH:mm");
  const endTime = moment(taskDetails.end_time).format("HH:mm");

  // Calculate reminder difference
  const reminderDiff = moment(taskDetails.start_time).diff(
    moment(taskDetails.reminder_timestamp)
  );
  const duration = taskDetails.reminder_timestamp
    ? moment.duration(reminderDiff)
    : null;

  const reminderText = duration
    ? getReminderPresetLabel(
        taskDetails.start_time,
        taskDetails.reminder_timestamp
      )
    : "No reminder";
  // const reminderText = duration ?
  //   duration.asMinutes() < 60
  //     ? `${Math.floor(duration.asMinutes())} minutes`
  //     : `${Math.floor(
  //         duration.asHours()
  //       )} hours, ${duration.minutes()} minutes` : 'No reminder';

  //logs

  const subTextStyle = { marginLeft: 30, color: "#555" };
  const listItemStyle = {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
  };
  const rowStyle = {
    display: "flex",
    alignItems: "center",
    width: "100%",
  };

  const cleanUrl = (url) => url.replace(/\\\//g, "/");
  const attachments = taskDetails.attachment_urls || [];
  const attachmentCount = attachments.length;

  const handleDownload = async (url, filename) => {
    try {
      const response = await fetch(url, { method: "GET" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const handleviewOpen = () => {
    setEditView(false);
  };

  return (
    <>
      <Modal
        open={isOpen}
        onCancel={handleClose}
        footer={null}
        centered
        width={500}
        confirmLoading={loading}
        maskClosable={false}
      >
        {metaLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 200,
            }}
          >
            <span>Loading...</span>
            {/* Or use <Spin size="large" /> from antd for a spinner */}
          </div>
        ) : !editView ? (
          <div>
            {/* Header Section */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <h3>Event</h3>
              <div>
                {taskDetails &&
                  (taskDetails.permission === null ||
                    taskDetails.permission?.id === 6 ||
                    participants.some(
                      (a) => a.member.user_id === userInfo.user_id
                    )) && (
                    <Button
                      type="primary"
                      icon={<EditOutlined />}
                      style={{ marginRight: 8 }}
                      onClick={handleEditOpen}
                    >
                      Edit Event
                    </Button>
                  )}
                <Button
                  type="text"
                  // onClick={() => setIsDeleteModalVisible(true)}
                  onClick={() =>
                    handleDeleteTaskEvent(
                      eventData?.type,
                      eventData?.event_master_id || eventData?.task_master_id,

                      moment(selectedDate, "D, MMMM YYYY").format("YYYY-MM-DD")
                    )
                  }
                  icon={<DeleteOutlined style={{ color: "#9A4FE0" }} />}
                />
              </div>
            </div>

            {/* Task Details */}
            <div style={{ marginTop: 16 }}>
              <h3 style={{ marginTop: 5 }}>
                <strong>Title:</strong> {taskDetails.title}
              </h3>
              <div style={{ marginTop: 5 }}>
                {taskDetails.description && (
                  <Text>
                    <strong>Description</strong> : {taskDetails.description}
                  </Text>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  // alignItems: "center",
                  gap: "10px",
                  marginTop: 5,
                }}
              >
                <h3>
                  <strong>Location:</strong>
                </h3>
                <div className="">
                  {taskDetails.location ? (
                    <Text>{taskDetails.location}</Text>
                  ) : (
                    "No Location"
                  )}
                </div>
              </div>
              {attachmentCount > 0 && (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <h3>Attachments</h3>
                  {attachmentCount > 0 && (
                    <>
                      <Tooltip title="View All Attachments">
                        <Button
                          icon={<PaperClipOutlined />}
                          onClick={() =>
                            setAttachmentModal({
                              visible: true,
                              attachments: attachments.map((a) => ({
                                name: a.attachment_name,
                                url: cleanUrl(a.attachment_url),
                              })),
                            })
                          }
                        >
                          {attachmentCount}{" "}
                          {attachmentCount === 1 ? "File" : "Files"}
                        </Button>
                      </Tooltip>
                    </>
                  )}
                </div>
              )}

              {/* Status & Priority */}
              <div style={{ marginTop: 16 }}>
                <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>Status</h3>
                <Tag className="ant-tag-btn">{statusLabel}</Tag>
              </div>

              <div style={{ marginTop: 16 }}>
                <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
                  Preferred Display Name
                </h3>
                <Tag className="ant-tag-btn">{displayLabel}</Tag>
              </div>

              <div style={{ marginTop: 16 }}>
                <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
                  Priority
                </h3>
                <Tag className="ant-tag-btn">{priorityLabel}</Tag>
              </div>
              <div style={{ marginTop: 16 }}>
                <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
                  Assigned by
                </h3>
                <Tag className="ant-tag-btn">
                  {(assignBy && assignBy?.name) || ""}{" "}
                </Tag>
              </div>
              {checklist && checklist.length > 0 && (
                <div style={{ marginTop: 16 }}>
                  <h3 style={{ fontWeight: "bold" }}>Checklist</h3>
                  <List
                    dataSource={checklist}
                    renderItem={(item) => (
                      <List.Item>
                        <Checkbox checked={!!item.is_checked}>
                          {item.title}
                        </Checkbox>
                      </List.Item>
                    )}
                  />
                </div>
              )}
              {/* Task Metadata */}
              <div style={{ marginTop: 16 }}>
                <h3>Details</h3>

                <List>
                  {/* <List.Item style={listItemStyle}>
                  <div style={rowStyle}>
                    <CalendarOutlined style={iconStyle} />
                    <Text style={{ fontWeight: 500 }}>Assign</Text>
                  </div>
                  <Text style={subTextStyle}>
                    {getAssignee?.[0]?.member?.name || 'No Assignee'}
                  </Text>
                </List.Item> */}

                  <List.Item style={listItemStyle}>
                    <div style={rowStyle}>
                      <TeamOutlined style={iconStyle} />
                      <Text style={{ fontWeight: 500 }}>Participants</Text>
                    </div>
                    <Text style={subTextStyle}>
                      {getCollaboraters?.length
                        ? getCollaboraters
                            .map((c) => c?.member?.name)
                            .join(", ")
                        : "No Participants"}
                    </Text>
                  </List.Item>

                  <List.Item
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <CalendarOutlined
                        style={{ marginRight: 8, fontSize: "22px" }}
                      />
                      <Text strong>Date</Text>
                    </div>
                    <Text style={{ marginLeft: 28 }}>{formattedDate}</Text>
                  </List.Item>

                  <List.Item
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <ClockCircleOutlined
                        style={{ marginRight: 8, fontSize: "22px" }}
                      />
                      <Text strong>Time</Text>
                    </div>
                    <Text style={{ marginLeft: 28 }}>
                      {selectedTime.start && selectedTime.end
                        ? `${selectedTime.start} - ${selectedTime.end}`
                        : "Not Set"}
                    </Text>
                  </List.Item>

                  <List.Item
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <BellOutlined
                        style={{ marginRight: 8, fontSize: "22px" }}
                      />
                      <Text strong>Reminder</Text>
                    </div>
                    <Text style={{ marginLeft: 28 }}>{reminderText}</Text>
                  </List.Item>

                  <List.Item
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <RepeatOnOutlined
                        style={{
                          marginRight: 8,
                          fontSize: "22px",
                          color: "#666",
                        }}
                      />
                      <Text strong>Repeat</Text>
                    </div>
                    <Text style={{ marginLeft: 28 }}>
                      {eventData?.repeat_option
                        ? `${eventData.repeat_option
                            .charAt(0)
                            .toUpperCase()}${eventData.repeat_option.slice(1)}`
                        : "No Repeat"}{" "}
                      {eventData?.repetition_end_date &&
                        `(End until ${moment(
                          eventData.repetition_end_date
                        ).format("D, MMMM YYYY")})`}
                    </Text>
                  </List.Item>

                  <List.Item
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <ColorLensOutlinedIcon style={{ marginRight: 8 }} />
                      <Text strong>Color</Text>
                    </div>
                    <Text style={{ marginLeft: 28 }}>{colorLabel}</Text>
                  </List.Item>
                </List>
              </div>
            </div>
          </div>
        ) : (
          <div>
            {/* Edit View */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "20px",
                marginBottom: 10,
              }}
            >
              <h3>
                <EditOutlined /> Edit Event
              </h3>
              <div>
                <Button className="reset-btn" onClick={handleviewOpen}>
                  Cancel
                </Button>
              </div>
              {/* <Button className="reset-btn" onClick={resetFormFields}>Reset</Button> */}
            </div>

            <div className="addTaskLabel">
              <FloatLabel label="Task name" name="title" value={formData.title}>
                <Input
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  status={error ? "error" : ""}
                />
              </FloatLabel>
            </div>

            <FloatLabel
              label="Description"
              name="description"
              value={formData.description}
            >
              <Input.TextArea
                name="description"
                value={formData.description}
                onChange={handleChange}
                autoSize={{ minRows: 1, maxRows: 6 }}
              />
            </FloatLabel>

            <FloatLabel
              label="Location"
              name="location"
              value={formData.location}
            >
              <Input
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
            </FloatLabel>

            {/* Status */}
            <div style={{ marginTop: 16 }}>
              <div className="radio-container">
                <h3
                  className="radio-label"
                  style={{ marginBottom: 0, fontSize: 16 }}
                >
                  Status
                </h3>
                <Radio.Group
                  className="custom-radio-group"
                  onChange={(e) => {
                    setSelectedRadio(e.target.value);
                    setFormData((prev) => ({
                      ...prev,
                      progress_status_id: e.target.value,
                    }));
                  }}
                  value={selectedRadio}
                >
                  {progressStatus.map((status) => (
                    <Radio
                      key={status.id}
                      value={status.id}
                      className="custom-radio"
                    >
                      {status.label_name}
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
            </div>

            {/* Display Name */}
            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
                Preferred Display Name
              </h3>
              {displayName.map((item) => {
                return (
                  <Tag
                    key={item.id}
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        display_name_id: item.id,
                      }))
                    }
                    style={{
                      backgroundColor:
                        Number(formData.display_name_id) === item.id
                          ? "#FEF1FE"
                          : "#ffffff",
                      color:
                        Number(formData.display_name_id) === item.id
                          ? "#9A4FE0"
                          : "#000",
                      border:
                        Number(formData.display_name_id) === item.id
                          ? "1px solid #9A4FE0"
                          : "1px solid #E1E6EF",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontSize: "14px",
                      padding: "8px 12px",
                    }}
                  >
                    {item.label_name}
                  </Tag>
                );
              })}
            </div>
            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
                Assigned by
              </h3>
              <Tag className="ant-tag-btn">
                {(assignBy && assignBy?.name) || ""}{" "}
              </Tag>
            </div>

            {/* Priority */}
            <div style={{ marginTop: 16 }}>
              <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>Priority</h3>
              {priority.map((item) => {
                // console.log("item>>>>>>>>>",typeof(item.id) , typeof(formData.priority_id))
                return (
                  <Tag
                    key={item.id}
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, priority_id: item.id }))
                    }
                    style={{
                      backgroundColor:
                        Number(formData.priority_id) === item.id
                          ? "#FEF1FE"
                          : "#ffffff",
                      color:
                        Number(formData.priority_id) === item.id
                          ? "#9A4FE0"
                          : "#000",
                      border:
                        Number(formData.priority_id) === item.id
                          ? "1px solid #9A4FE0"
                          : "1px solid #E1E6EF",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontSize: "14px",
                      padding: "8px 12px",
                    }}
                  >
                    {item.label_name}
                  </Tag>
                );
              })}
            </div>

            {/* Date/Time/Reminder */}
            <div style={{ marginTop: 16 }}>
              <div className="details-container">
                <h3 className="details-title">Details</h3>

                {/* Assignee and collaborators start */}
                {/* <DetailsList
                  icon={<AssignmentOutlined style={iconStyle} />}
                  title="Assign To"
                  description={selectedNames}
                  switchChecked={assignedUsers?.length > 0}
                  onSwitchChange={() => setShowAssignModal(true)}
                  onClick={() => setShowAssignModal(true)}
                /> */}
                <ChecklistComponent
                  checklist={checklist}
                  setChecklist={setChecklist}
                />
                <DetailsList
                  icon={<AssessmentOutlined style={iconStyle} />}
                  title="Participants"
                  description={descSelectedCollaboration}
                  switchChecked={switchStatesCollaboration}
                  onSwitchChange={() => {
                    // Always open modal instead of toggling
                    setShowCollaborationModal(true);
                  }}
                  onClick={() => {
                    if (switchStatesCollaboration) {
                      setShowCollaborationModal(true);
                    }
                  }}
                />
                {/* Assignee and collaborators end */}
                {/* <DetailsList
                  icon={<CalendarOutlined />}
                  title="Date"
                  description={formattedDate || "No date selected"}
                  onClick={() => setShowModal(true)}
                /> */}
                <DetailsList
                  icon={<CalendarOutlined style={iconStyle} />}
                  title="Date"
                  description={selectedDate || "No date selected"}
                  switchChecked={switchStates}
                  onSwitchChange={() => setShowModal(true)}
                  onClick={() => setShowModal(true)} // Open modal on click
                />

                {/* <DetailsList
                  icon={<ClockCircleOutlined style={iconStyle} />}
                  title="Time"
                  description={
                    startTime && endTime
                      ? `${startTime} - ${endTime}`
                      : "Not Set"
                  }
                  switchChecked={switchTimeStates}
                  onSwitchChange={() => setShowTimeModal(true)}
                  onClick={() => setShowTimeModal(true)}
                /> */}
                <DetailsList
                  icon={<ClockCircleOutlined style={iconStyle} />}
                  title="Time"
                  description={
                    selectedTime.start && selectedTime.end
                      ? `${selectedTime.start} - ${selectedTime.end}`
                      : "Add time"
                  }
                  switchChecked={switchTimeStates}
                  onSwitchChange={() => setShowTimeModal(true)}
                  onClick={() => setShowTimeModal(true)}
                />

                <DetailsList
                  icon={<BellOutlined style={iconStyle} />}
                  title="Reminder"
                  description={
                    descSelectedReminder === "No reminder"
                      ? "No Reminder"
                      : descSelectedReminder
                  }
                  switchChecked={switchStatesRem}
                  onSwitchChange={handleSwitchChangeRem}
                  onClick={() => setShowRemModal(true)}
                />

                <DetailsList
                  icon={<RepeatOnOutlined style={iconStyle} />}
                  title="Repeat"
                  description={getRepeatDescription()}
                  switchChecked={switchStatesRepeat}
                  onSwitchChange={handleSwitchChangeRepeat}
                  onClick={() => setShowRepeatModal(true)}
                />
                <DetailsList
                  icon={<ColorLensOutlined style={iconStyle} />}
                  title="Color"
                  description={descSelectedColor}
                  switchChecked={switchStatesColor}
                  onSwitchChange={handleSwitchChangeColor}
                  onClick={() => setShowColorModal(true)}
                />
              </div>
            </div>

            {/* Action Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
                gap: "5px",
              }}
            >
              <Button
                className="modal-cancel-btn"
                onClick={() => setEditView(false)}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                className="modal-success-btn"
                // onClick={handleUpdateTask}
                onClick={() =>
                  handleUpdateEvent(
                    eventData?.type,
                    eventData?.event_master_id || eventData?.task_master_id,

                    moment(selectedDate, "D, MMMM YYYY").format("YYYY-MM-DD")
                  )
                }
                loading={loading}
              >
                Apply
              </Button>
            </div>
          </div>
        )}
      </Modal>

      {/* Modals */}

      {showAssignModal && (
        <AssignToModal
          visible={showAssignModal}
          onCancel={() => setShowAssignModal(false)}
          onSave={(newSelection) => {
            setAssignedUsers(newSelection);
            setShowAssignModal(false);
          }}
          // selectedUsers={ getAssignee || assignedUsers}
          selectedUsers={getAssignee.map((a) => a.member)}
          users={AssignData}
        />
      )}

      {showCollaborationModal && (
        <CollaborationModal
          visible={showCollaborationModal}
          onCancel={() => {
            setSelectedCollaborators([]);
            setShowCollaborationModal(false);
          }}
          onSave={handleSaveCollaboration}
          collaborators={dummyCollaborators}
          initialSelected={selectedCollaborators}
          permissionMetadata={permission}
          // tabName={tabName} // <-- Pass the tab name here
        />
      )}
      {showModal && (
        <DateModalTask
          show={showModal}
          handleClose={() => setShowModal(false)}
          onDateSelect={handleDateSelect}
          // selectedDate={selectedDate}
          selectedDate={
            moment(selectedDate, "D, MMMM YYYY").isValid()
              ? moment(selectedDate, "D, MMMM YYYY").toDate()
              : null
          }
        />
      )}

      {showTimeModal && (
        <TimeSelect
          show={showTimeModal}
          handleClose={() => setShowTimeModal(false)}
          onSelectTime={handleSelectTime}
          selectedTime={selectedTime}
          selectedDate={selectedDate}
        />
      )}
      {showRemModal && (
        <Reminder
          show={showRemModal}
          handleClose={handleRemModalClose}
          onSelectReminder={handleSelectReminder}
          eventDate={selectedDate}
          eventTime={selectedTime}
          selectReminderTime={setDescSelectedReminder}
          initialReminder={descSelectedReminder}
          eventData={eventData}
        />
      )}
      {showColorModal && (
        <ColorsModal
          visible={showColorModal}
          onCancel={() => setShowColorModal(false)}
          onSave={handleColorSave}
          metaData={colorMetaData}
          initialSelectedColor={selectedColor}
        />
      )}

      {showRepeatModal && (
        <RepeatModal
          visible={showRepeatModal}
          onCancel={handleRepeatCancel}
          onSave={handleRepeatSave}
          initialValues={repeatConfig}
          repeatOption={repeatOption}
          adjustWeeknd={adjusWeekend}
          startDate={selectedDate} // 👈 This must be defined above this point
        />
      )}

      {isDeleteModalVisible && (
        <DeleteConfirmationModal
          visible={isDeleteModalVisible}
          onConfirm={handleConfirmDelete}
          onCancel={() => setIsDeleteModalVisible(false)}
        />
      )}

      {isModalVisible && (
        <RecurringEventModal
          visible={isModalVisible}
          action="delete"
          occurrenceDate={selectedItemForDelete?.occurrenceDate}
          onClose={() => setIsModalVisible(false)}
          onConfirm={handleConfirmDelete}
        />
      )}
      {isModaUpdatelVisible && (
        <RecurringEventModal
          visible={isModaUpdatelVisible}
          action="update"
          occurrenceDate={selectedItemForDelete?.occurrenceDate}
          onClose={() => setIsUpdateModalVisible(false)}
          onConfirm={handleConfirmUpdate}
        />
      )}

      <Modal
        title="Attachments"
        open={attachmentModal.visible}
        onCancel={() => setAttachmentModal({ visible: false, attachments: [] })}
        footer={null}
      >
        {attachmentModal.attachments.map((file, idx) => (
          <Button
            key={idx}
            type="default"
            icon={<DownloadOutlined />}
            style={{ marginBottom: 8, width: "100%" }}
            onClick={() => handleDownload(file.url, file.name)}
          >
            Download{" "}
            {file.name.length > 20 ? `${file.name.slice(0, 20)}...` : file.name}
          </Button>
        ))}
      </Modal>
    </>
  );
};

export default ViewEvent;
